var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "18px",
    width: "17px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m485.7,198.5c-10.7-13.4-25.3-20.8-41.1-20.8h-36.1c-3.4-92.6-70.5-166.7-152.5-166.7-82,0-149.1,74.1-152.5,166.7h-36.1c-15.8,0-30.4,7.4-41.1,20.8-13.5,16.8-18.4,40.2-13.3,62.7l43.3,190.8c6.5,28.8 28.9,49 54.4,49h290.5c25.5,0 47.9-20.1 54.4-49l43.4-190.8c5.1-22.5 0.2-45.9-13.3-62.7zm-229.7-146.7c59.6-1.42109e-14 108.4,55.8 111.6,125.9h-223.2c3.2-70 52-125.9 111.6-125.9zm203.2,200.3l-43.3,190.9c-2.2,9.8-8.5,17.2-14.6,17.2h-290.6c-6.1,0-12.4-7.4-14.6-17.2l-43.3-190.9c-2.3-10.1-3.7-33.6 14.6-33.6h377.2c19.7,0 16.9,23.5 14.6,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.7,259.1c-11.3,0-20.4,9.1-20.4,20.4v127.5c0,11.3 9.1,20.4 20.4,20.4 11.3,0 20.4-9.1 20.4-20.4v-127.5c0.1-11.2-9.1-20.4-20.4-20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.6,259.1c-11.3,0-20.4,9.1-20.4,20.4v127.5c0,11.3 9.1,20.4 20.4,20.4 11.3,0 20.4-9.1 20.4-20.4v-127.5c0-11.2-9.2-20.4-20.4-20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.4,259.1c-11.3,0-20.4,9.1-20.4,20.4v127.5c0,11.3 9.1,20.4 20.4,20.4 11.3,0 20.4-9.1 20.4-20.4v-127.5c5.68434e-14-11.2-9.1-20.4-20.4-20.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shopping-basket.2f1b959a9856cef35a8bef7605b58837.svg";
export { ForwardRef as ReactComponent };